
import AdminSideBar from '../../components/adminSideBar/AdminSideBar';
import StatistiquesAujourdhui from '../../components/statistiques/statistiquesAujourdhui/StatistiquesAujourdhui';
import StatistiqueGloabal from '../../components/statistiques/statistiquesGlobal/StatistiqueGloabal';
import './home.css';

function Home() {
  //test2
  return (
    
    <div className='container-global'>
      <AdminSideBar activeTab="home" />
      <div className='center'>
        <div className="title">
          <span className="material-symbols-rounded">shoppingmode</span>
          <span>Dashboard</span>
        </div>

        <StatistiquesAujourdhui />
        {/* <StatistiqueGloabal /> */}
      </div>
    </div>
  )
}
export default Home
